<template>
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M20 7L15 12L20 17M4 7L9 12L4 17"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
      vector-effect="non-scaling-stroke"
    />
  </svg>
</template>
